const initialState = {
  organizationData: []
};

export default function organizationReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_ORGANIZATION_DATA":
      return {
        ...state,
        organizationData: action.organizationData,
      };
    default:
      return state;
  }
}
